import Image from 'next/image';

import { NsfwReason, RegisterInbound } from '~features/annals';
import { useSession } from '~hooks/useSession';

import { useSwitchSafeModeWithAgeValidation } from '../../hooks/useSwitchSafeMode';
import { NSFWModeSwitchContainer } from './NSFWModeSwitch.styles';

export const NSFWModeSwitch = () => {
	const updateSafeMode = useSwitchSafeModeWithAgeValidation();
	const { isSafeMode } = useSession();

	const handleClick = () => {
		void updateSafeMode(!isSafeMode, {
			force: true,
			nsfwReason: NsfwReason.TopBanner,
			registerInbound: RegisterInbound.HeaderNsfwAction,
		});
	};

	return (
		<NSFWModeSwitchContainer onClick={handleClick}>
			<p>Spicy</p>
			<Image
				width={16}
				height={16}
				src={isSafeMode ? '/img/nsfw/eye-none.png' : '/img/nsfw/eye-open.png'}
				quality={100}
				alt="nsfw mode icon"
			/>
		</NSFWModeSwitchContainer>
	);
};
